import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue'
import FormAddressField from 'components/FormAddressField/FormAddressField.vue'
import nameValidator from "foundation/js/inputValidators/nameValidator"
import phoneValidator from "foundation/js/inputValidators/phoneValidator"

export default {
    name: "EditProfileForm",
    components: {
        FormInputTextField,
        FormAddressField,
    },
    props: {
        pageId: {
            type: Number,
            required: true
        },
        userProfileId: {
            type: String,
            required: true
        },
        userData: {
            type: Object,
            required: true
        },
        deleteProfileUrl: {
            type: String,
            required: true
        },
        isNewUser: {
            type: Boolean,
            required: true
        },
        privacyPolicyHtml: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const store = useStore()

        const privacyPolicyWrapper = ref(null)
        const isSubmitting = ref(false)
        const displayError = ref(false)
        const firstName = ref(props.userData.firstname ?? '')
        const lastName = ref(props.userData.lastname ?? '')
        const phone = ref(props.userData.telephone ?? '')
        const address = ref(props.userData.address ?? '')
        const postalCode = ref(props.userData.postalCode ?? '')
        const city = ref(props.userData.city ?? '')

        const linkToDeleteConfirmationPage = props.userData.hasCancerforumProfile || props.userData.hasFrivilligProfile || props.userData.hasStafetForLivetProfile || props.userData.hasMenopauseProfile

        const isRequired = {
            firstName: props.userData.hasFrivilligProfile || props.userData.hasStafetForLivetProfile,
            lastName: props.userData.hasFrivilligProfile || props.userData.hasStafetForLivetProfile,
            phone: props.userData.hasFrivilligProfile,
            address: props.userData.hasFrivilligProfile
        }

        const isFirstNameValid = computed(() => 
            isRequired.firstName
                ? nameValidator(firstName.value)
                : firstName.value === "" || nameValidator(firstName.value)
        )

        const isLastNameValid = computed(() => 
            isRequired.lastName
                ? nameValidator(lastName.value)
                : lastName.value === "" || nameValidator(lastName.value)
        )  

        const isPhoneValid = computed(() => isRequired.phone
            ? phoneValidator(phone.value)
            : phone.value === '' || phoneValidator(phone.value)
        )

        const isAddressValid = computed(() => isRequired.address
            ? address.value !== ''
            : true
        )
        
        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'EditProfileForm',
                labelKey: labelKey
            })

        const decodeHtml = (htmlRaw) => {
            const txt = document.createElement('textarea')
            txt.innerHTML = htmlRaw
            return txt.value
        }

        onMounted(() => {
            var privacyPolicyHtmlDecoded = decodeHtml(props.privacyPolicyHtml)
            privacyPolicyWrapper.value.innerHTML = privacyPolicyHtmlDecoded
        })

        const cancel = () => {

            if (props.continueUrl) {
                window.location.href = props.continueUrl
            }
            else {
                history.back()
            }
        }

        const submit = async () => {

            const isValid = isFirstNameValid.value && isLastNameValid.value && isPhoneValid.value && isAddressValid.value
            if (!isValid) {
                displayError.value = true
                return
            }
            
            isSubmitting.value = true
            displayError.value = false

            try {
                var refreshLoginUrl = await store.dispatch('main/updateUserProfile', {
                    userProfileId: props.userProfileId,
                    pageId: props.pageId,
                    body: {
                        firstname: firstName.value,
                        lastname: lastName.value,
                        phone: phone.value,
                        address: address.value,
                        postalCode: postalCode.value,
                        city: city.value
                    }
                })

                window.location.href = refreshLoginUrl
            }
            catch {
                isSubmitting.value = false
            }
        }

        const openDeleteOverlay = function (e) {
            store.commit('main/set_page_overlay_content_data', { 
                userProfileId: props.userProfileId 
            })
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'DeleteGlobalProfileOverlay',
                returnTarget: e.currentTarget
            })
        }
        
        return {
            getLabel,
            displayError,
            firstName,
            lastName,
            phone,
            address,
            postalCode,
            city,
            isRequired,
            isFirstNameValid,
            isLastNameValid,
            isPhoneValid,
            isAddressValid,
            isSubmitting,
            cancel,
            submit,
            privacyPolicyWrapper,
            linkToDeleteConfirmationPage,
            openDeleteOverlay
        }
    }
}